/* eslint-disable css-modules/no-unused-class */
import { FC } from 'react';
import { CardLoader, Icon, ProgressIndicator } from 'learning-panel-components';
import styles from './primaryCourse.module.scss';

const PrimaryCourse: FC<PrimaryCourseProps> = (props: PrimaryCourseProps) => {
    const { isLoading, score, completionPercentage, competedLessons, totalLessons } = props;

    return isLoading ? (
        <CardLoader width="100%" height="100%" />
    ) : (
        <div data-testid="primary-course" className={styles['primary-course']}>
            <Icon name="courseIconLearningPanel" />
            <hr />
            <div className={styles.progress}>
                <Icon name="primaryCourseClose" />
                <ProgressIndicator direction={'vertical'} value={completionPercentage} />
                <div className={styles.text}>{`${Math.trunc(completionPercentage)}%`}</div>
            </div>
            <div>
                <hr />
                <div className={styles.lessons}>
                    <Icon name="lessonIconLearningPanel" />
                    <div>{totalLessons ? `${competedLessons}/${totalLessons}` : 0}</div>
                </div>
                <hr />
                <div className={styles.score}>
                    <Icon name="devCoin" />
                    <div>{score?.toLocaleString()}</div>
                </div>
            </div>
        </div>
    );
};

export default PrimaryCourse;

interface PrimaryCourseProps {
    isLoading: boolean;
    score: number;
    completionPercentage: number;
    competedLessons: number;
    totalLessons: number;
}
